<div fxFlex="column" class="confirm-dialog">

  <div class="dialog-header">
    Confirmation - {{ title }}
  </div>

  <div class="dialog-container" fxLayout="column">

    <div class="dialog-body">
      <div *ngIf="isLoading" class="spinner-wrapper">
        <mat-spinner [diameter]="50" mode="indeterminate"></mat-spinner>
      </div>
      <div *ngIf="!isLoading" fxLayout="column">
        <div fxFlex fxLayout="column" fxLayoutAlign="space-around" fxLayoutGap="10px grid">
          <div class="student-container" *ngFor="let student of students" fxLayoutAlign="center center">
            <mat-card fxFlex class="student-card"
              [ngClass]="{'selected': mappedStudents.indexOf(student.StudentID) !== -1}" fxLayout="row"
              fxLayoutAlign="space-around center" (click)="onStudentSelect(student.StudentID)">
              <div fxFlex="75" class="module-name">
                {{ student.StudentName }}
              </div>
            </mat-card>
            <span>
              <mat-icon class="check-icon" [ngClass]="{'success': mappedStudents.indexOf(student.StudentID) !== -1}">
                check_circle_outline</mat-icon>
            </span>
          </div>
        </div>
      </div>
    </div>

    <div class="button-container" fxLayout="row" fxLayoutAlign="space-around center">
      <div>
        <button class="cancel-button button" mat-button type="button" (click)="onCancel()">
          Cancel
        </button>
      </div>
      <div>
        <button [disabled]="mappedStudents.length === 0" class="submit-button button" mat-button type="button" (click)="onRemoveFromSkipped()">
          Remove from Skipped
        </button>
      </div>
    </div>
  </div>
